export default "__VITE_ASSET__KaOaKCxI__"